import React from 'react';
import { observer } from 'mobx-react-lite';

import { ErrorPopup } from '../../modals/error-popup';
import { useStore } from '../../../hooks';

interface ModalsProps {

}

export const Modals: React.FC<ModalsProps> = observer(() => {

  const { modalStore, maintenanceStore } = useStore();
  const { gameInterruptionModalState } = modalStore;

  // The maintenance page ends the session on purpose: no game error or idle timeout is shown over it.
  if (maintenanceStore.isMaintenanceMode) return null;

  return (
    <>
      {
        gameInterruptionModalState.isOpen && (
          <ErrorPopup
            hasExit={!!gameInterruptionModalState.data?.hasExit}
            hasClose={!!gameInterruptionModalState.data?.hasClose}
            hasReload={!!gameInterruptionModalState.data?.hasReload}
            title={gameInterruptionModalState.data?.title || ''}
            message={gameInterruptionModalState.data?.message || ''}
            displayErrorCode={gameInterruptionModalState.data?.displayErrorCode}
          />
        )
      }
      
    </>
  );
});
